import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ColorService {
    constructor() {}

    // algo from http://codepen.io/WebSeed/pen/pvgqEq
    calculateForegroundColor(bgColor: string): string {
        let color = '#000000';

        const illum = this.calculateIllumination(bgColor);
        if (illum >= 0.5) {
            color = '#FFFFFF';
        }

        return color;
    }

    private calculateIllumination(color: string): number {
        const rgb = this.hexToRgb(color);
        return 1 - (0.299 * parseInt(rgb[0], 16) + 0.587 * parseInt(rgb[1], 16) + 0.114 * parseInt(rgb[2], 16)) / 255;
    }

    private hexToRgb(hex: string): string[] {
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        const fullHex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });
        return /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex)!.slice(1);
    }

    private darkenColor(colorSegments: string[]): number[] {
        // make color Darker by adding 10 to every color segment
        return colorSegments.map((color) => {
            const number = parseInt(color);
            return number - 80;
        });
    }

    private extractNumbersFromRgb(rgb: string): string[] {
        return rgb
            .substring(4, rgb.length - 1)
            .replace(/ /g, '')
            .split(',');
    }

    private buildRgbString(colorSegment: number[]): string {
        return `rgb(${colorSegment[0]}, ${colorSegment[1]}, ${colorSegment[2]})`;
    }

    buildEventBorderColor(rgb: string): string {
        return this.buildRgbString(this.darkenColor(this.extractNumbersFromRgb(rgb)));
    }
}
